import React from 'react';
import PropTypes from 'prop-types';
import { BoxSummary, ProductSelector } from '../../components';
import { CheckoutBar } from '../CheckoutBar';
import {
  BoxSummaryContainer,
  HeaderContainer,
  Headline,
  HeroContainer,
  Subheadline,
} from './styles';

export const ProductSelectionForm = ({
  checkoutBar,
  boxSummary,
  headline,
  legend,
  subheadline,
  onChange,
  onSubmit,
  productSelector,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <HeroContainer>
        <HeaderContainer>
          <Headline>{headline}</Headline>
          <Subheadline>{subheadline}</Subheadline>
        </HeaderContainer>
        <fieldset>
          {legend && <legend>{legend}</legend>}
          <ProductSelector {...productSelector} onChange={onChange} />
        </fieldset>
        {boxSummary && (
          <BoxSummaryContainer>
            <BoxSummary {...boxSummary} />
          </BoxSummaryContainer>
        )}
      </HeroContainer>
      <CheckoutBar {...checkoutBar} />
    </form>
  );
};
ProductSelectionForm.displayName = 'ProductSelectionForm';
ProductSelectionForm.propTypes = {
  boxSummary: PropTypes.object,
  checkoutBar: PropTypes.object.isRequired,
  headline: PropTypes.string.isRequired,
  legend: PropTypes.string,
  productSelector: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  subheadline: PropTypes.node.isRequired,
};
